import React, { PropsWithChildren } from "react";
import { Icon } from "../../../shared/Icon/Icon";
import { IconDefinition } from "../../../shared/Icon/Icon.generated";
import { GroupActionList } from "../GroupActionList/GroupActionList";

export const GroupItem = ({
  id,
  name,
  icon,
  description,
  handleEditGroup,
  handleDeleteGroup,
}: PropsWithChildren<{
  id: string;
  name: string;
  icon: IconDefinition;
  description: string;
  handleEditGroup: () => void;
  handleDeleteGroup: () => Promise<void>;
}>) => {
  return (
    <div className="GroupTable__item">
      <Icon className="mb-1" icon={icon} />
      <h6 className="mb-1" onClick={handleEditGroup}>
        {name}
      </h6>
      <span className="mb-1">{description}</span>
      <GroupActionList
        id={id}
        name={name}
        handleDeleteGroup={handleDeleteGroup}
        handleEditGroup={handleEditGroup}
      />
    </div>
  );
};
